import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';

// Constantes do Bolsão (SuspenseAccount/constants.ts e suspenseAccount.type.ts:1-67), declaradas uma vez:
// rótulos em `msg`, valores técnicos do fio como estão.

/** Nome do CSV quando o `Content-Disposition` não diz (constants.ts:7). */
export const SUSPENSE_ACCOUNT_EXPORT_FILE_NAME = 'bolsoes-e-movimentos.csv';

/**
 * Tipos de movimento (`SuspenseAccountMovementTypeEnum`, suspenseAccount.type.ts:8-33). Os manuais trocaram de
 * valor no backend (2 e 6); a exibição usa sempre o `typeDisplay` da resposta.
 */
export const MOVEMENT_TYPE = {
  surplusEntry: 1,
  manualEntry: 2,
  settlementWithdrawal: 3,
  refundWithdrawal: 4,
  initialLoad: 5,
  manualWithdrawal: 6,
} as const;

/** Os seis tipos, na ordem do legado: o filtro "Tipo do movimento" do extrato (`movementTypeFilterOptions`). */
export const MOVEMENT_TYPES = defineEnum({
  '1': { label: msg`Entrada - Sobra de repasse` },
  '2': { label: msg`Entrada - Lançamento manual` },
  '3': { label: msg`Saída - Liquidação de parcela` },
  '4': { label: msg`Saída - Devolução` },
  '5': { label: msg`Entrada - Carga inicial` },
  '6': { label: msg`Saída - Ajuste manual` },
});

/** O que o operador pode lançar (suspenseAccount.type.ts:35-47): entrada só manual; saída devolução ou ajuste. */
export const ENTRY_FORM_TYPES = ['2'] as const;
export const WITHDRAWAL_FORM_TYPES = ['4', '6'] as const;

/*
 * Os selects do legado mandam `'true'`/`'false'` (suspenseAccount.type.ts:55-67). Na URL vão palavras (o roteador
 * leria `true` como booleano e o filtro cairia); o fio recebe o texto do legado pelo `toParam`.
 */

/** "Saldo" da lista (`suspenseAccountOnlyWithBalanceOptions`): Todos = `false`. */
export const ONLY_WITH_BALANCE = [
  { value: 'todos', label: msg`Todos` },
  { value: 'com-saldo', label: msg`Somente com saldo` },
] as const;
export const onlyWithBalanceParam = (value: string) => (value === 'com-saldo' ? 'true' : 'false');

/** "Origem" da lista e do extrato (`suspenseAccountHasConciliationOptions`). */
export const HAS_CONCILIATION = [
  { value: 'com', label: msg`Com conciliação` },
  { value: 'sem', label: msg`Sem conciliação` },
] as const;
export const hasConciliationParam = (value: string) => (value === 'com' ? 'true' : 'false');

/** "Lançamento manual" do extrato (`suspenseAccountOnlyManualOptions`): uma opção só, `true`. */
export const ONLY_MANUAL = [{ value: 'sim', label: msg`Somente lançamentos manuais` }] as const;
export const onlyManualParam = () => 'true';

/** Status da conciliação no aviso do 409 CONCILIACAO_EM_PROCESSAMENTO (methods.ts:37-46). */
export function conciliationStatusLabel(status: number | undefined) {
  if (status === 1) return msg`Integrando`;
  if (status === 5) return msg`Liquidando cobranças`;
  return msg`em processamento`;
}
